<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'LayoutAside',
})
</script>
<template>
	<SqtDrawer
		v-model="modelValue"
		:show-close="false"
		direction="ltr"
		custom-class="layout-aside"
		modal-class="layout-aside-modal"
	>
		<template #header>
			<!-- 套壳关抽屉时立刻藏，避免和 header 叠帧；Web 一直显示 -->
			<Expand v-show="showAsideExpand" v-model="modelValue" />
		</template>
		<div class="menu-container">
			<MenuTree :open-tab="openTab" />
			<MenuList :open-tab="openTab" />
		</div>
	</SqtDrawer>
</template>
<script lang="ts" setup name="LayoutAside">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { SqtDrawer } from '@sqt/ui/es/components/drawer'
import { SqtMessageBox } from '@sqt/ui/es/components/message-box'
import { isNativeApp } from '../../utils/native'
import Expand from '../components/expand.vue'
import MenuTree from '../components/menu-tree.vue'
import MenuList from '../components/menu-list.vue'

const router = useRouter()
const { t } = useI18n()
const isNative = isNativeApp()

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
})
const emit = defineEmits(['update:modelValue'])
/** 壳内仅展开时显示；Web 始终显示 */
const showAsideExpand = computed(() => !isNative || props.modelValue)
const openTab = (path: string) => {
	emit('update:modelValue', false)
	// 菜单可以先挂 pagePath，页面还没进路由表时 resolve 会落到 404 的 :pathMatch
	const resolved = path ? router.resolve(path) : undefined
	if (
		!resolved?.matched.length ||
		resolved.matched.some((record) => record.path.includes(':pathMatch'))
	) {
		SqtMessageBox({
			title: t('message'),
			message: t('coming_soon_message'),
		})
		return
	}
	router.push(path)
}
const modelValue = computed({
	get: () => props.modelValue,
	set: (value: boolean) => emit('update:modelValue', value),
})
</script>
<style lang="scss" scoped>
:deep(.layout-aside) {
	width: max-content !important;
	max-height: 100%;
	background-color: var(--grey-color--14);
	box-shadow: none;

	.sqt-drawer__header {
		position: relative;
		height: 0;
		padding: 0;
		overflow: unset;

		.expand-icon {
			position: absolute;
			top: 0;
			left: 100%;
			background-color: var(--grey-color--14);
			border-radius: 0 0 10px;
		}
	}

	.sqt-drawer__body {
		display: flex;
		flex-direction: column;
		min-height: 0;
		padding: 0;
		overflow: hidden;
		user-select: none;
		background-color: var(--grey-color--14);

		.sqt-text {
			cursor: pointer;
		}
	}
}

.menu-container {
	display: flex;
	flex: 1 1 0;
	min-height: 0;
	overflow: hidden;

	> * {
		min-height: 0;
	}
}
</style>
